module.exports = __webpack_public_path__ + "img/sp.0323f133.png";